// only edit brown text
import home from "../images/home.png";
import phone from "../images/phoneWhite.png";
import web from "../images/website.png";
import mail from "../images/mailWhite.png";

export const profession = "Full Stack Web Developer";

export const address = [
  // "22 Knightsbridge",
  // "High Street",
  // "Inverurie",
  // "Aberdeenshire",
  // "AB51 3TL",
];

export const contact = [
  { icon: home, type: "Location", value: "Aberdeen / London / Kuwait" },
  { icon: phone, type: "Phone", value: "+44 7534 551759 (WhatsApp)" },
  { icon: phone, type: "Phone", value: "+965 9988 6921" },
  { icon: mail, type: "eMail", value: "james.r.grantham@gmail.com" },
  { icon: web, type: "Portfolio", value: "jamesgrantham.me" },
  //  { type: "LinkedIn", value: "linkedin.com/in/j-grantham" },
  //  { type: "GitHub", value: "github.com/jrgrantham" },
];

export const skills = [
  {
    description:
      "Communication: Liaised with onshore teams, offshore / remote teams and the client.",
  },
  // learning - award
  // innovation - creativity
  // leadership / development
  { description: "Problem-Solving" },
  { description: "Adaptability" },
  { description: "Interpersonal" },
  { description: "Teamwork" },
  { description: "Creativity" },
  { description: "Leadership" },
  { description: "Organisation" },
];

export const software = [
  "Git & git workflow",
  "React",
  "JavaScript",
  "CSS",
  "Python",
  "Node JS",
  "Styled Components",
  "Redux",
  "mySQL",
  "Testing",
];

export const leadership = [
  "Influenced senior management and guided a team of 11 to make project changes and improvements.",
  "Mentored junior staff.",
];

export const achievements = [
  "Increased project efficiency by 30%.",
  "Received award for highest known API570 exam result (97%).",
  "Improved project KPIs.",
];

export const statement = [
  "20 years experienced, dynamic and adaptable, with a track record of innovation and client focus. ",
  "Highly skilled in project management, improving workflow systems and data management, consistently improving KPI's on all projects. ",
  // "Continuous self improvement, received award for highest known API570 exam result (97%). ",
  "Newly trained in web development and striving to achieve efficient, simple and intuitive interfaces.",
];
// Enjoys pair programming, problem solving and hopes to work in a friendly and engaging team to learn from and contribute to.
// quality driven
// api score
//Dynamic and detail-oriented Web Developer with a knack for conceptualizing and delivering elegant, user-friendly solutions effectively and efficiently. Possesses a track record of developing an e-commerce mobile app, a CRM online portal and a fully-functional website for a nonprofit working with underprivileged children. Armed with an extensive understanding of end-to-end SDLC and cloud computing. Regular participant and organizer of local hackathons and web developer meetups.
//fast learner

export const history = [
  {
    date: "10/2020 - Current",
    role: "Full Stack Web Developer",
    company: "Intangible Engineering",
    description: "Building bespoke platforms to client specifications.",
    location: "London, UK",
    info: [
      "Developed a project management and costing platform for a London based consultancy firm: Data collection for multiple projects, managing risks, scheduling tasks and assigning staffing levels.",
    ],
  },
  {
    date: "07/2019 - 02/2020",
    role: "Full Stack Web Developer",
    company: "Lambda School",
    description:
      "A nine-month online computer science academy for aspiring software engineers and data scientists.",
    location: "Aberdeen, UK",
    info: [
      // "Independently developed a risk management app and server for a London based consultancy firm. Utilising React, redux, bcryptjs and nodejs, users can customise views, select from filtered templates (if account type permits), populate with their data and can download the raw data and/or formatted and customised documents.",
      "Collaborated in a six-man team on an e-commerce app to support underfunded schools. Seller and buyer accounts, version controlled with git, deployed utilising continuous integration and testing, a fully functioning app with payment processing.",
      "Python build week - online MUD game. Wrote an algorithm to create a maze returning a traversable grid with a million 'rooms'.",
      // "Built a portfolio website.",
      // "Created a Ricky and Morty Fan Club Site. Using axios to fetch data into redux, users can select favourite characters, to view further information.",
    ],
  },
  {
    date: "12/2012 - 06/2019",
    role: "Inspection Engineer",
    company: "Oceaneering",
    description:
      "A global provider of engineered services and products to the offshore oil and gas industry.",
    location: "Aberdeen, UK",
    info: [
      "Managed day to day operations of the integrity contract (£1.3m) for the Kittiwake Oil Platform, supervised both local and remote teams, delivered the annual inspection scope on time and witin budget.",
      "Developed new tracking systems and reporting processes, increasing project transparency and efficiency onshore by ~30%.",
      "Managed the development of an internal company project to convert the monthly presentation into a website accessible by client, supplying live data available any time.",
      "Reviewed inspection reports, categorised anomalies, generated anomaly reports and raised repair recommendations.",
    ],
  },
  {
    date: "12/2001 - 12/2012",
    role: "Project Engineer",
    company: "Lloyd's Register",
    description:
      "A leading international provider of classification, compliance and consultancy services to the marine industry.",
    location: "Aberdeen, UK",
    info: [
      "Risk assessments, integrity reviews, repair recommendations fitness for service calculations, anomaly ranking and categorisation, inspection workpacks and a seven-month corrosion under insulation project offshore.",
    ],
    role2: "Graduate Engineer",
    info2: "Introduced to Risk Management and the world of Integrity Services.",
  },
];

export const education = [
  {
    date: "07/2019 - 04/2020",
    title: "Full Stack Web Development",
    school: "Lambda School",
    info:
      "A nine-month online Computer and Software Engineering course. 2,000 hours of intensive, hands-on experience, working with people from around the world.",
  },
  {
    date: "08/1997 - 06/2001",
    title: "Bachelor of Mechanical Engineering",
    school: "University of Loughborough",
    info: "",
  },
];

export const interests = [
  {
    title: "Mountain Biking",
    info:
      "A long term favourite activity, now all three of my boys enjoy it too, especially if it's wet and muddy!",
  },
  // {
  //   title: "Music",
  //   info:
  //     "J",
  // },
  {
    title: "Aquarium",
    info:
      "A long awaited dream to own and manage a home aquarium. Now settled in Kuwait I have set up a 450 litre fresh-water aquarium for turtles and fish.",
  },
  // {
  //   title: "Crawling and Trail Running",
  //   info:
  //     "Building, maintaining and modifying remote control rock crawlers with my three children. These are assembled from kits and customised to our liking, we enjoy soldering and getting them running. Another excuse to get outside.",
  // },
];
